import React, {Component} from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Button, Table, message } from 'antd';
import { PopUpForm } from '../../../lib/ui/popupform';
import { showErrorInNotification, formatMoney } from '../../../lib/util';

const unlabelled_cols=({onAssignClicked})=>[
    {title:"Label Name",dataIndex:'source_id'},
    {title:"Count",dataIndex:'count',key:'count'},
    {title:"",dataIndex:'source_id',key:'action',render:(source_id)=><Button type='primary' onClick={()=>{
        typeof onAssignClicked==='function'&&onAssignClicked(source_id)
    }}>Assign</Button>}
]

class UnlabelledSources extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_visibility:false,
            label:null
        };

        this.list_unlabelled=RESTExecutor.list().config({
            label:'unlabeled_sources',
            params:{
                per_page:10
            }
        }).connect(props.domains.source);

        this.assign_source=RESTExecutor.post().config({
            label:'assign_label'
        }).callbacks((success)=>{
            message.success("Assigned Successfully");
            this.setState({form_visibility:false,label:null})
            typeof props.onNeedRefresh==='function'&&props.onNeedRefresh()
            this.list_unlabelled.execute();
        },(error)=>{
            showErrorInNotification(error)
        }).connect(props.domains.source);

    };

    render() {
        let list_unlabelled_resp=this.list_unlabelled.response();
        let rowsData=(list_unlabelled_resp.result&&list_unlabelled_resp.result.rows)||[];
        let rowsMeta=list_unlabelled_resp.meta||{};
        const source_schema=[
            {name:"Source",index:'source_id',type:'networkselect',url:`/sources`}
        ]
        return (
            <div>
                 <PopUpForm
                    title={`Assign Source for ${this.state.label}`}
                    show_title_only
                    forCreate={true}
                    initialData={{}}
                    fields={source_schema}
                    open={this.state.form_visibility}
                    okText="Assign"
                    networkState={{}}
                    onClose={() => this.setState({form_visibility: false,label:null})}
                    onSubmit={(data) => {
                        if(data.source_id){
                            this.assign_source.forId(data.source_id).execute({
                                label:this.state.label
                            })
                        }else{
                            message.warning("Source must be selected");
                        }

                }}/>
            <Table 
            className='main-table'
            bordered={false}
            size='small'
            scroll={{x:true}}
            columns={unlabelled_cols({onAssignClicked:(label)=>{
                this.setState({label:label,form_visibility:true})
            }})}
            dataSource={rowsData}
            loading={list_unlabelled_resp.fetching}
            pagination={{
                // simple: true,
                onChange: (current, size) => {
                    this
                        .list_unlabelled
                        .config({
                            params: {
                                per_page: size,
                                page: current
                            }
                        })
                        .execute();
                },
                defaultCurrent: 1,
                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                pageSize: (rowsMeta && rowsMeta.requested_count),
                total: (rowsMeta && rowsMeta.total_count),
                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
            }}
            />
            </div>
        );
    }

    componentDidMount(){
        this.list_unlabelled.execute();
    }
}

export default withDomains(UnlabelledSources,"source");
